import { useState } from "react";
import Select from "react-select";
import Button from "../UI/Button";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { addDoc, collection } from "firebase/firestore";
import { db } from "@/firebase/firebaseConfig";

const AddProduct = ({ onClose }) => {
  const [img, setImg] = useState(null);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    lastMonthSales: "",
    purchasePrice: "",
    marketplacePrice: "",
    profit: "",
    minQuantity: "",
    recQuantity: "",
    style: "",
    logistContact: "",
    supplierContact: "",
  });

  const countries = [
    { value: "США", label: "США" },
    { value: "ОАЭ", label: "ОАЭ" },
    { value: "Европа", label: "Европа" },
    { value: "Япония", label: "Япония" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImg(file);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (!img) {
        alert("Пожалуйста, загрузите картинку для товара.");
        return;
      }

      let imageUrl = "";

      const storage = getStorage();
      const storageRef = ref(storage, `products/${Date.now()}-${img.name}`);
      await uploadBytes(storageRef, img);
      imageUrl = await getDownloadURL(storageRef);

      const newProduct = {
        imageUrl: imageUrl,
        countries: selectedCountries.map((c) => c.value),
        ...formData,
      };

      await addDoc(collection(db, "products"), newProduct);

      alert("Продукт успешно добавлен!");
      onClose();
    } catch (error) {
      console.error("Ошибка при добавлении товара:", error);
      alert("Ошибка при добавлении товара!");
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  return (
    <div className="editProduct productCard-modal">
      <div className="editProduct-content">
        {Object.entries(formData).map(([key, value]) => (
          <div className="editProduct-content-item" key={key}>
            <label htmlFor={key}>{key}</label>
            <input
              className="input"
              id={key}
              name={key}
              type="text"
              value={value}
              onChange={handleInputChange}
            />
          </div>
        ))}

        <div className="editProduct-content-item">
          {img && (
            <img src={URL.createObjectURL(img)} width={100} alt="Product" />
          )}
          <label htmlFor="image">Загрузить картинку</label>
          <input
            type="file"
            accept="image/*"
            name="image"
            id="image"
            onChange={handleImageUpload}
          />
        </div>

        <div className="editProduct-content-item">
          <label htmlFor="country">Страны</label>
          <Select
            className="basic-multi-select"
            classNamePrefix="select"
            isMulti
            options={countries}
            value={selectedCountries}
            onChange={setSelectedCountries}
          />
        </div>

        {loading ? (
          <Button onClick={() => null} disabled title="Сохраняем"></Button>
        ) : (
          <Button
            onClick={handleSubmit}
            color="blue"
            title="Сохранить"
          ></Button>
        )}

        <Button onClick={onClose} title="Закрыть"></Button>
      </div>
    </div>
  );
};

export default AddProduct;
